import React from 'react';
import type { UiMode, ModeDefinition } from './types';
import DefaultModeApp from './default/DefaultModeApp';

// Employee mode is lazy-loaded for code-splitting
const EmployeeModeApp = React.lazy(() => import('./employee/EmployeeModeApp'));

export const MODE_REGISTRY: Record<UiMode, ModeDefinition> = {
  default: {
    id: 'default',
    label: 'Default',
    component: DefaultModeApp,
    hasVoiceInterface: true,
  },
  employee: {
    id: 'employee',
    label: 'Employee',
    component: EmployeeModeApp,
    hasVoiceInterface: false,
  },
};

export function getModeDefinition(mode: UiMode): ModeDefinition {
  return MODE_REGISTRY[mode] || MODE_REGISTRY['default'];
}

export type { UiMode, ModeDefinition } from './types';
